import { render, staticRenderFns } from "./prompt-tab.vue?vue&type=template&id=330a2548&scoped=true"
import script from "./prompt-tab.vue?vue&type=script&lang=js"
export * from "./prompt-tab.vue?vue&type=script&lang=js"
import style0 from "./prompt-tab.vue?vue&type=style&index=0&id=330a2548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a2548",
  null
  
)

export default component.exports